import { mapActions } from 'vuex'
import spacetime from 'spacetime'

export default {
	methods: {
		...mapActions('Flows', ['fetchFlows']),
		duplicate(flow) {
			const duplicateFlowBody = {
				flow_id: flow.flow_id,
			}

			this.$axios
				.post('v1/flows/duplicate', duplicateFlowBody)
				.then(async res => {
					this.loading = false
					this.$stanAnalytics('flow-duplicated', {
						meta: { user_id: this.user.user_id, username: this.user.username },
						props: {
							flow_id: res.data.flow_id,
						},
					})
					await this.fetchFlows()
					if (res.data.type === this.$constants.FLOW_TYPE.EVENT_TRIGGERED) {
						this.$stanNotify({
							type: 'success',
							title: this.$t('Done!'),
							text: this.$t('Your flow has been duplicated.'),
						})
						this.focusFlow(res.data.flow_id)
					} else if (res.data.type === this.$constants.FLOW_TYPE.USER_TRIGGERED) {
						this.$stanNotify({
							type: 'success',
							title: this.$t('Done!'),
							text: this.$t('Your broadcast has been duplicated.'),
						})
						this.scrollToBroadcast(res.data.flow_id)
					}
				})
				.catch(() => {
					this.$stanNotify({
						type: 'error',
						title: this.$t('Something went wrong'),
						text: this.$t('Please contact us at friends@stanwith.me'),
					})
				})
		},
		checkSchedule(schedule) {
			const { selectedDate, selectedTime, selectedTimezone } = schedule

			try {
				// Parse and validate inputs
				const [year, month, day] = selectedDate.split('-').map(Number)
				const hour = Math.floor(selectedTime)
				const minute = Math.round((selectedTime % 1) * 60)

				if (hour > 23 || minute > 59) {
					throw new Error(`Invalid time value: ${hour}:${minute}`)
				}

				// Create spacetime instances
				const scheduledTime = spacetime([year, month - 1, day, hour, minute], selectedTimezone)
				const currentTime = spacetime.now(selectedTimezone)

				// Calculate time difference
				const timeDifference = currentTime.diff(scheduledTime, 'minutes')

				return {
					isAtLeastNow: timeDifference >= 0,
					isAtLeast10MinutesFromNow: timeDifference >= 10,
				}
			} catch (error) {
				return {
					isAtLeastNow: false,
					isAtLeast10MinutesFromNow: false,
				}
			}
		},
	},
}
